import React from 'react';
import { Dialog, DialogContent, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { useDeviceType } from 'contexts/ThemeContext/hooks/useDeviceType';
import { ModalHeader } from 'components/ModalHeader/ModalHeader';

interface DeveloperToolsModalProps {
  open: boolean;
  onClose: () => void;
  onFeatureFlags: () => void;
  onSignUpTestUser: () => void;
}

export const DeveloperToolsModal = ({
  open,
  onClose,
  onFeatureFlags,
  onSignUpTestUser,
}: DeveloperToolsModalProps) => {
  const { isDesktop } = useDeviceType();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="developer-tools-title"
      fullScreen={!isDesktop}
      PaperProps={{
        sx: {
          minWidth: isDesktop ? '400px' : '100%',
        },
      }}
    >
      <ModalHeader
        modalTitle="Developer Tools"
        onClickBack={onClose}
        onClickClose={onClose}
        showBackButton={!isDesktop}
        showCloseButton={isDesktop}
        modalTitleProps={{ id: 'developer-tools-title' }}
      />
      <DialogContent>
        <List>
          <ListItem disablePadding>
            <ListItemButton onClick={onFeatureFlags} data-testid="feature-flags-option">
              <ListItemText primary="Feature Flags" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={onSignUpTestUser} data-testid="sign-up-test-user-option">
              <ListItemText primary="Sign Up Test User" />
            </ListItemButton>
          </ListItem>
        </List>
      </DialogContent>
    </Dialog>
  );
};
